import { themes } from '@probeton/style';
export default themes.light;
